import React from 'react';
import { setShopReducer } from './../Redux/Reducers/shopReducer';

import { useDispatch } from 'react-redux';
import { setGoodsReducer, appendGoodsReducer, setAppendGoodsReducer, updateGoodsData } from './../Redux/Reducers/goodsReducer';
import { setBasketReducer,
    addItemToBasketClone,
    updateSettingsCounts,
    updateItemCountBasket,
    removeItemBasket,
    addItemToBasket,
    setCategories,
    updateItemCountBasketClone,
    removeItemBasketClone,
    updateItemHidedDataBasket
} from './../Redux/Reducers/shopReducer';
import { useSelector } from 'react-redux';

import { Axios, AxiosM } from './axios';
import axios from 'axios';
import { buildBasketCounterReducerAction } from './basketCounterState';

export const useShopAPI = () => {

    const dispatch = useDispatch();

    const userData = useSelector(state => state.user);
    const ShopSession = useSelector(state => state.shop.shop);
    const SettingsSession = useSelector(state => state.shop.shop.settings);

    function objectToFormData(obj, formData = new FormData(), parentKey = '') {
        Object.keys(obj).forEach(key => {
            const value = obj[key];
            const formKey = parentKey ? `${parentKey}[${key}]` : key;

            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    if (typeof item === 'object') {
                        objectToFormData(item, formData, `${formKey}[${index}]`);
                    } else {
                        formData.append(`${formKey}[]`, item);
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                objectToFormData(value, formData, formKey);
            } else {
                formData.append(formKey, value);
            }
        });
        return formData;
    }

    const handleUpdateCountBasketElement = async (itemId, newCount,clone) => {
        if(clone) {
            await dispatch(updateItemCountBasketClone(itemId, newCount));
        } else {
            await dispatch(updateItemCountBasket(itemId, newCount));
        }
        return true;
    };

    const handleDeleteBasketElement = async (itemId, cloneid) => {
        if(cloneid !== false) {
            await dispatch(removeItemBasketClone(itemId));
        } else {
            await dispatch(removeItemBasket(itemId));
        }
        return true;
    };

    const handleAddItemBasketElement = async (newItem, clone) => {
        if(clone) {
            await dispatch(addItemToBasketClone(newItem));
        } else {
            await dispatch(addItemToBasket(newItem));
        }

        return true;
    };

    let cancelTokenSource;

    const getGoods = async (params, abortCtrl, handleCloseLoadingGoods, clone = false) => {
        if (userData.user !== null) {
            const formData = objectToFormData({
                ...params,
                userid: userData.user.userid,
                token: userData.user.token,
                shopidindex: userData.user.shopid,
                countGoods: ShopSession.settings.countGoods,
                addedToday: ShopSession.settings.addedToday
            });

            try {
                const { data } = await Axios.post('get/goods', formData, {
                    signal: abortCtrl.signal
                });

                if(data.status !== undefined && data.status === 'error') {
                    dispatch(setGoodsReducer([{error: data.message}]));
                    return;
                }

                const newSettings = {
                    countGoods: data.total_goods,
                    addedToday: data.added_today,
                };

                dispatch(updateSettingsCounts(newSettings));

                const items = Array.isArray(data.items) ? data.items : [];

                const goodsFixSizes = items.map(item => {
                    if (item.sizes === null || item.sizes === undefined || item.sizes === "" || item.sizes === "[]" || item.sizes === '[""]') {
                        return { ...item, sizes: '0' };
                    }
                    return item;
                });

                const Ad = data.ad;

                if(Ad !== false && Ad !== 'false' && Ad !== null && Ad !== undefined) {
                    data.items = [
                        Ad,
                        ...goodsFixSizes,
                    ]
                } else {
                    data.items = [
                        ...goodsFixSizes,
                    ]
                }

                if(params.append === true) {

                    dispatch(appendGoodsReducer({
                        ...data.items,
                    }));

                } else {
                    dispatch(setGoodsReducer({
                        ...data.items,
                    }));
                }

                return {
                    success: 1,
                    goods: data.items
                }
            }
            catch (err) {
                if (axios.isCancel(err)) {
                    
                } else {
                    console.error("Error loading goods", err);
                    dispatch(setGoodsReducer([]));
                }
            } finally {
                handleCloseLoadingGoods();
            }
        }
    };

    const getBasket = async() => {

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token
        });

        try {
            const { data } = await Axios.post('get/basket', formData, { timeout: 5000 });

            dispatch(setBasketReducer({
                ...data,
            }));

            return {
                success: 1,
                data: data
            }


        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const getGood = async(goodID) => {

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            itemID: goodID,
            token: userData.user.token
        });

        try {
            const { data } = await Axios.post('get/good', formData);

            return {
                success: 1,
                good: data
            }


        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const changeHidedGood = async(good, hided) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            goodID: good.id,
            hided: hided,
            token: userData.user.token
        });

        try {
            const { data } = await Axios.post('adminpanel/updateHidedGood', formData);

            dispatch(updateGoodsData({
                ...good,
                hided: data.hided
            }));
            dispatch(updateItemHidedDataBasket(good.id, data.hided));

            return {
                success: 1,
                good: {
                    ...good,
                    hided: data.hided
                },
            }


        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const CounterGoodAction = async(action, basketID, setLoading, count, cloneid = false) => {
        setLoading(true);

        window.Telegram.WebApp.HapticFeedback.impactOccurred('light');

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            operator: action,
            basket: basketID,
            setCount: count,
            cloneid: cloneid
        });

        try {
            const { data } = await Axios.post('basket/counter', formData);

            const reducerAction = buildBasketCounterReducerAction(data, basketID, cloneid);
            if (reducerAction) {
                dispatch(reducerAction);
            } else if (data.status === 'error') {
                window.Telegram.WebApp.showAlert(data.message);
            }

            return {
                success: 1,
                data: data
            }


        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        } finally {
            setLoading(false);
        }
    };

    const AddItemBasketAction = async(good, size, setLoading, clone = false) => {
        setLoading(true);

        window.Telegram.WebApp.HapticFeedback.impactOccurred('light');

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            itemID: good.id,
            size: size,
            cloneid: clone ? clone : 0
        });

        try {
            const { data } = await Axios.post('basket/add', formData, { timeout: 5000 });

            if(data.status !== undefined && data.status === 'success') {
                const newItem = {
                    cost: good.cost,
                    costs_change: good.costs_change,
                    count: good.countAddBasket,
                    countAddBasket: good.countAddBasket,
                    id: data.basketId,
                    item_id: good.id,
                    hided: good.hided,
                    photo: good.photo,
                    shopID: userData.user.shopid,
                    size: size,
                    title: good.title,
                    vendor_code: good.vendor_code,
                    isDigit: good.isDigit
                };

                handleAddItemBasketElement(newItem, clone);
            } else if(data.status !== undefined && data.status === 'error') {
                window.Telegram.WebApp.showAlert(data.message);
            }

            setLoading(false);

            return {
                success: 1,
                data: data
            }


        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const AddItemBasketByIDAction = async(itemID, size, clone = false) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            itemID: itemID,
            size: size,
            cloneid: clone ? clone : 0
        });

        try {
            const { data } = await Axios.post('basket/add', formData, { timeout: 5000 });

            return {
                success: data.status !== undefined && data.status === 'success' ? 1 : 0,
                data: data
            }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const SetBasketItemCountAction = async(basketID, count, clone = false) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            operator: 'set',
            basket: basketID,
            setCount: Math.max(1, Number(count) || 1),
            cloneid: clone
        });

        try {
            const { data } = await Axios.post('basket/counter', formData, { timeout: 5000 });

            return {
                success: data.status !== undefined && data.status !== 'error' ? 1 : 0,
                data: data
            }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const buyDigitGood = async(goodID) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            goodID: goodID,
            from_card: true
        });

        try {
            const { data } = await Axios.post('payment/buyDigitGood', formData);

            return data;
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const getPhotosGood = async (good) => {

        var goodID = good.id

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            itemID: goodID,
            from_card: true
        });

        try {
            const { data } = await Axios.post('get/images', formData);

            good.description = data.description;

            dispatch(updateGoodsData({
                ...good
            }));

            return {
                photos: data.images
            }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const getCategories = async (catalogID = 0, shopid = 0) => {

        if(userData.user !== null) {
            var formData = [];
            if(shopid > 0) {
                formData = objectToFormData({
                    userid: userData.user.userid,
                    token: userData.user.token,
                    offset: 0,
                    limit: 400,
                    catalogID: catalogID,
                    shopidindex: userData.user.shopid,
                    shopid: shopid,
                });
            } else {
                formData = objectToFormData({
                    userid: userData.user.userid,
                    shopid: userData.user.shopid,
                    token: userData.user.token,
                    offset: 0,
                    limit: 400,
                    catalogID: catalogID,
                });
            }
            try {
                const { data } = await Axios.post('get/categories', formData);

                dispatch(setCategories({
                    ...data.categories,
                }));

                return {
                    data: data
                }
            }
            catch (err) {
                return { success: 0, message: 'Server Error!' };
            }
        }
    }

    const getCatalog = async () => {

        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token
        });

        try {
            const { data } = await Axios.post('get/catalog', formData);

            return data.catalog
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const createOrder = async(sendObject) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            shopids: JSON.stringify(ShopSession.settings.shops),
            ...sendObject
        });

        try {
            const { data } = await Axios.post('basket/createOrder', formData);

            return { data: data }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const getLoyaltySummary = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
        });

        try {
            const { data } = await Axios.post('loyalty/summary', formData);
            return data;
        }
        catch (err) {
            return { status: 'error', message: 'Server Error!' };
        }
    }

    const sharedGood = async(goodID) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            goodID: goodID
        });

        try {
            const { data } = await Axios.post('basket/sharedGood', formData);

            window.Telegram.WebApp.showAlert('Карточка товара была отправлена в Telegram бота. Вы можете переслать ее другим людям!');
            window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
            return { data: data }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const sendMailing = async (textMailing, mediaFile = null) => {
        if (typeof textMailing !== 'string') {
            console.error('textMailing должен быть строкой');
            return;
        }

        const formData = new FormData();
        formData.append('userID', userData.user.userid);
        formData.append('shopID', userData.user.shopid);
        formData.append('textMailing', textMailing);
        formData.append('token', userData.user.token);

        // Добавляем файл, только если он есть
        if (mediaFile) {
            formData.append('media', mediaFile);
        }

        try {
            const response = await Axios.post('adminpanel/sendMailing', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'  // Важно для правильной обработки файлов
                }
            });

            if (response.data.result) {
                window.Telegram.WebApp.showAlert('Рассылка успешно отправлена пользователям магазина');
                window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
                return { data: response.data };
            }
        } catch (err) {
            console.error('Ошибка при отправке данных: ', err);
            return { success: 0, message: 'Server Error!' };
        }
    }

    const changeParameterEnv = async(key, value) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            key: key,
            value: value,
        });

        try {
            const { data } = await Axios.post('adminpanel/changeParameter', formData);

            let object = SettingsSession;

            if (object.hasOwnProperty(key)) {
                if(key === 'hide_main_category') {
                    value = value === '0' ? false : true;
                    object[key] = value;
                } else {
                    object[key] = value;
                }
            }

            dispatch(setShopReducer({
                orderClone: ShopSession.orderClone,
                settings: object
            }));

            window.Telegram.WebApp.HapticFeedback.impactOccurred('light');

            return { data: data }
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    }

    const getAllCategories = async () => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/getAllCategories', objectToFormData(data));

            return response.data;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const editCategoryName = async (categoryid, editText) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            categoryid: categoryid,
            editText: editText,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/editCategoryName', objectToFormData(data));

            return response.data;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const deleteCategory = async (categoryid) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            categoryid: categoryid,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/deleteCategory', objectToFormData(data));

            return response.data;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const deleteCategories = async (categoryids) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            categoryids: categoryids,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/deleteCategories', objectToFormData(data));

            return response.data;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const addCategory = async (categoryName) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            categoryName: categoryName,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/addCategory', objectToFormData(data));

            return response.data;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const getAdminGoods = async (categoryid, searchText, page) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            categoryid: categoryid,
            searchText: searchText,
            page: page,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/getAdminGoods', objectToFormData(data));

            return {
                goods: response.data.goods,
                countProducts: response.data.countProducts
            };

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const deleteGoods = async (ids) => {
        const data = {
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            ids: ids,
            token: userData.user.token
        };

        try {
            const response = await Axios.post('adminpanel/deleteGoods', objectToFormData(data));

            return response.data.goods;

        } catch (error) {
            console.error('Error sending data to API:', error);
            return null;
        }
    };

    const changeLanguage = async(language_code) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
            language_code: language_code
        });

        const { data } = await Axios.post('changeLanguage', formData);

        return { success: 1, data: data };
    };

    const getAdministrators = async() => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getAdministrators', formData);

        return { success: 1, data: data };
    }

    const addAdministrator = async({ adminID, permissions }) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            adminID: adminID,
            ...permissions,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/addAdministrator', formData);

        return { success: 1, data: data };
    }

    const deleteAdministrator = async(adminID) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            adminID: adminID,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/deleteAdministrator', formData);

        return { success: 1, data: data };
    }

    const getAcquirings = async() => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getAcquirings', formData);

        return { success: 1, data: data };
    }

    const sendMePdfOwner = async(newValue) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            newValue: newValue,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/sendMePdfOwner', formData);

        return { success: 1, data: data };
    }

    // const getLevels, addLevel, updateLevel, deleteLevel

    const getLevels = async() => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('get/customerLevels', formData);

        return { success: 1, data: data };
    }

    const deleteLevel = async(customerLevelId) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            customerLevelId: customerLevelId,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/deleteCustomerLevel', formData);

        return { success: 1, data: data };
    }

    const updateLevel = async(level) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            // newValue: newValue,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/updateCustomerLevel', formData);

        return { success: 1, data: data };
    }

    const addLevel = async(level) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
            ...level
        });

        const { data } = await Axios.post('adminpanel/addCustomerLevel', formData);

        return { success: 1, data: data };
    }

    const createInviteAdministratorLink = async(permissions) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
            ...permissions
        });

        const { data } = await Axios.post('adminpanel/createInviteAdministratorLink', formData);

        return data;
    }

    const updateAcquiringStatus = async(id, value) => {
        const formData = objectToFormData({
            userid: userData.user.userid,
            shopid: userData.user.shopid,
            token: userData.user.token,
            id: id,
            value: value
        });

        const { data } = await Axios.post('adminpanel/updateAcquiringStatus', formData);

        return data;
    }

    const getFieldsOrder = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token
        });

        const { data } = await Axios.post('adminpanel/getFieldsOrder', formData);

        return data;
    }

    const storeFields = async(fields) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            fields: fields
        });

        const { data } = await Axios.post('adminpanel/storeFields', formData);

        return data;
    }

    const updateBanner = async(bannerFile) => {
        const formData = new FormData();
        formData.append('userID', userData.user.userid);
        formData.append('shopID', userData.user.shopid);
        formData.append('token', userData.user.token);
        formData.append('bannerFile', bannerFile);

        const { data } = await Axios.post('adminpanel/updateBannerFile', formData);

        if(data.status === 'success') {

        }

        return data;
    }

    const getPaymentMethodsList = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getPaymentMethodsList', formData);

        return data;
    }

    const deletePaymentType = async(id) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            integrationID: id
        });

        const { data } = await Axios.post('adminpanel/deletePaymentType', formData);

        return data;
    }

    const addPaymentType = async(payment_token, bankID) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            payment_token: payment_token,
            bankID: bankID
        });

        const { data } = await Axios.post('adminpanel/addPaymentType', formData);

        return data;
    }

    const getCurrencyList = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token
        });

        const { data } = await Axios.post('adminpanel/getCurrencyList', formData);

        return data;
    }

    const updateCurrency = async(code, sign) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            code: code
        });

        const { data } = await Axios.post('adminpanel/updateCurrency', formData);

        if(data.status === 'success') {
            dispatch(setShopReducer({
                orderClone: ShopSession.orderClone,
                settings: {
                    ...ShopSession.settings,
                    currency_sign: data.currency_sign,
                    currency: data.currency
                }
            }));
        }

        return data;
    }

    const updateCost = async(array) => {

        window.Telegram.WebApp.MainButton.showProgress();

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            type: array.type,
            value: array.value,
            category: array.category
        });

        const { data } = await Axios.post('adminpanel/updateCost', formData);
        window.Telegram.WebApp.MainButton.hideProgress();

        return data;
    }

    const cancelLastUpdateCost = async(array) => {

        window.Telegram.WebApp.MainButton.showProgress();

        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/cancelLastUpdateCost', formData);
        window.Telegram.WebApp.MainButton.hideProgress();

        return data;
    }

    const getCustomPaymentMethods = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getCustomPaymentMethods', formData);

        return data;
    }

    const addCustomPaymentMethod = async(title, requisites) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            title: title,
            requisites: requisites,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/addCustomPaymentMethod', formData);

        return data;
    }

    const editCustomPaymentMethod = async(methodID, active) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            // title: title,
            // requisites: requisites,
            methodID: methodID,
            active: active,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/editCustomPaymentMethod', formData);

        return data;
    }

    const deleteCustomPaymentMethod = async(methodID) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            methodID: methodID,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/deleteCustomPaymentMethod', formData);

        return data;
    }

    const getBotInfo = async() => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getBotInfo', formData);

        return data;
    }

    const updateHelloMessageBot = async(helloMessage, helloImage) => {
        const formData = objectToFormData({
            userID: userData.user.userid,
            shopID: userData.user.shopid,
            token: userData.user.token,
            helloMessage: helloMessage,
            helloImage: helloImage
        });

        const { data } = await Axios.post('adminpanel/updateHelloMessageBot', formData);

        return data;
    }

    const getTariffsData = async() => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getTariffsData', formData);

        return data;
    }

    const createPayment = async({ type_transaction, tariff_id }) => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token,
            type_transaction: type_transaction,
            tariff_id: tariff_id
        });

        const { data } = await Axios.post('payment/createPay', formData);

        return data;
    }

    const getStatistic = async() => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/getStatistic', formData);

        return data;
    }

    const lastUpdateCost = async() => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token,
        });

        const { data } = await Axios.post('adminpanel/lastUpdateCost', formData);

        return data;
    }

    const updateCategoryOrder = async(updatedOrder) => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token,
            updatedOrder: updatedOrder
        });

        const { data } = await Axios.post('adminpanel/updateCategoryOrder', formData);

        return data;
    }

    const mailingHistory = async() => {
        const formData = objectToFormData({
            userId: userData.user.userid,
            storeId: userData.user.shopid,
            token: userData.user.token
        });

        const { data } = await Axios.post('adminpanel/mailingHistory', formData);

        return data;
    }

    return { getGoods, getBasket, createPayment, mailingHistory, cancelLastUpdateCost, updateCategoryOrder, handleUpdateCountBasketElement, handleDeleteBasketElement, lastUpdateCost, getStatistic, getCustomPaymentMethods, getTariffsData, updateHelloMessageBot, getBotInfo, deleteCustomPaymentMethod, editCustomPaymentMethod, addCustomPaymentMethod, getPaymentMethodsList, updateCost, getCurrencyList, updateCurrency, addPaymentType, getAcquirings, updateBanner, deletePaymentType, updateAcquiringStatus, storeFields, getFieldsOrder, updateLevel, deleteLevel, buyDigitGood, createInviteAdministratorLink, addLevel, getLevels, addAdministrator, sendMePdfOwner, getAdministrators, deleteAdministrator, deleteGoods, changeLanguage, CounterGoodAction, getAdminGoods, getAllCategories, editCategoryName, deleteCategory, addCategory, deleteCategories, getCatalog, AddItemBasketAction, AddItemBasketByIDAction, SetBasketItemCountAction, changeParameterEnv, getPhotosGood, getCategories, createOrder, getLoyaltySummary, getGood, sharedGood, changeHidedGood, sendMailing };
};
